import React, { useMemo } from "react";
import { StyleSheet } from "react-native";
import NtText from "./NtText";
import { useTheme } from "../context/ThemeContext";

function NtModalSubtitle({ style, ...otherProps }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  return <NtText style={[styles.text, style]} {...otherProps} />;
}

const makeStyles = (t) =>
  StyleSheet.create({
    text: {
      color: t.textDim,
      fontSize: 12,
      fontWeight: "400",
      marginTop: 2,
      marginBottom: 8,
    },
  });

export default NtModalSubtitle;
